import type { RefObject } from "react";
import type { Toast } from "primereact/toast";

type ToastSeverity = "success" | "info" | "warn" | "error";

export type ToastMessage = {
  severity: ToastSeverity;
  summary: string;
  detail: string;
  life?: number;
};

export function showToast(
  toast: RefObject<Toast | null> | RefObject<Toast> | null,
  message: ToastMessage,
): void {
  if (toast?.current) {
    toast.current.show(message);
  }
}
